module.exports = __webpack_public_path__ + "static/media/building.1356544c.jpg";